// extracted by mini-css-extract-plugin
export default {"main-container":"Layout_main-container__2Vj1J","main-content":"Layout_main-content__kNJ9Q"};